import { useCallback, useRef } from 'react';
import type { FlatListProps } from 'react-native';
import { bridge } from 'shared/src/utils';
import type { HomeTabRoute } from '../components/HomeContents/HomeContents';
import { useActiveHomeTab } from './useActiveHomeTab';

/**
 * 상단 탭(HomeTabBar)이 가로 스크롤 뷰포트에 노출될 때 DISPLAY_UPPER_TAB 발화.
 * 탭별 1회만(route.id 기준 dedupe). CLICK_UPPER_TAB 과 동일 계열의 노출 로깅.
 */
export const useLogDisplayUpperTab = () => {
  const loggedRef = useRef<Set<string>>(new Set());
  const activeTab = useActiveHomeTab();

  const onViewableItemsChanged = useCallback<
    NonNullable<FlatListProps<HomeTabRoute>['onViewableItemsChanged']>
  >(
    ({ viewableItems }) => {
      viewableItems.forEach(({ index, isViewable, item }) => {
        if (activeTab) {
          if (index === null || !isViewable) return;
          if (loggedRef.current.has(item.id)) return;
          loggedRef.current.add(item.id);

          // Android 네이티브 홈의 DISPLAY_UPPER_TAB 과 파라미터 통일 (SCREEN/LABEL/INDEX).
          bridge.logAnalyticsEvent({
            name: 'DISPLAY_UPPER_TAB',
            analytics: {
              SCREEN: activeTab?.screen_name,
              LABEL: item.name,
              INDEX: index,
            },
          });
        }
      });
    },
    [activeTab],
  );

  return { onViewableItemsChanged };
};
